<app-header></app-header>

<main class="container mx-auto px-0 lg:px-6">
    <!-- Profile Info -->
    <div class="mt-20 lg:mt-24 px-4 lg:px-8">
        <div class="flex justify-between items-start">
            <div></div>
            <div class="flex space-x-2">
                <button id="writeStoryBtn" (click)="goToCreate()" class="pointer px-6 py-2 rounded-full font-medium bg-wattpad-secondary text-white hover:bg-[#009966] transition-colors">
                    {{t('ADD_NEW_EPISODE')}}
                </button>
            </div>
        </div>

        <!-- Tab Contents -->
        <div class="py-4">
            <!-- Stories Tab -->
            <div id="stories-tab" class="tab-content active">
                <div class="grid grid-cols-1 gap-4">
                    <!-- Episode Card -->
                    <div class="pointer bg-white dark:bg-gray-800 rounded-lg p-4 shadow-sm hover:shadow-md transition-all relative" *ngFor="let episode of stories">
                        <div class="actionbtn" *ngIf="isOwnProfile">
                            <button type="button" class="deletebutton" (click)="deleteStory(episode.id)">
                                <i class="fas fa-trash text-gray-500 hover:text-red-500 transition-colors"></i>
                            </button>
                            <button (click)="goToEdit(episode)" type="button" class="editbutton">
                                <i class="fas fa-edit text-gray-500 hover:text-red-500 transition-colors"></i>
                            </button>
                        </div>
                        
                        <div class="flex space-x-4">
                            <div class="flex-1 min-w-0">
                                <h3 class="font-bold text-lg lg:text-xl">{{ episode.story_title }} 
                                    <span [ngClass]="{
                                        'story-status': true,
                                        'status-published bg-success': episode.status == 1,
                                        'status-draft bg-warning': episode.status == 0
                                    }" *ngIf="isOwnProfile">
                                        {{ episode.status == 0 ? 'Draft' : 'Published' }}
                                    </span>
                                </h3>
                                
                                <div class="flex items-center mt-2 text-sm lg:text-base">
                                    <i class="fas fa-star text-yellow-400 mr-1"></i>
                                    <span>({{episode.total_ratings}}) • {{episode.views}} {{t('READS')}}</span>
                                </div>
                                
                                <p class="text-sm lg:text-base mt-2 line-clamp-2" [innerHTML]="episode.content"></p>
                                
                                <!-- Monetization Section - Only for published episodes and eligible users -->
<div *ngIf="isOwnProfile && episode.status == 1" class="mt-4 p-3 bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm">
    <div class="flex flex-col space-y-3">
        <!-- Header with Title and Toggle -->
        <div class="flex justify-between items-center">
            <div class="flex items-center space-x-2">
                <div class="p-2 bg-green-100 dark:bg-green-900/30 rounded-lg">
                    <i class="fas fa-rupee-sign text-green-600 dark:text-green-400 text-sm"></i>
                </div>
                <div>
                    <h4 class="font-semibold text-gray-800 dark:text-gray-200 text-sm">Premium Episode</h4>
                    <div class="flex items-center space-x-1">
                        <span class="text-xs text-gray-600 dark:text-gray-400">Status:</span>
                        <span [ngClass]="{
                            'text-xs px-2 py-0.5 rounded-full': true,
                            'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300': episode.monetization_enabled,
                            'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300': !episode.monetization_enabled
                        }">
                            {{ episode.monetization_enabled ? 'Active' : 'Inactive' }}
                        </span>
                    </div>
                </div>
            </div>
            
            <!-- Toggle Switch - Compact -->
            <div class="flex flex-col items-end space-y-1">
                <label class="relative inline-flex items-center cursor-pointer">
                    <input 
                        type="checkbox" 
                        [checked]="episode.monetization_enabled"
                        (change)="toggleMonetization(episode)"
                        [disabled]="!isMonetized || monetizationLoading"
                        class="sr-only peer">
                    <div class="w-10 h-5 bg-gray-300 peer-focus:ring-2 peer-focus:ring-green-300 rounded-full peer peer-checked:after:translate-x-5 peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-green-500"></div>
                </label>
                <span class="text-xs text-gray-500 dark:text-gray-400">
                    {{ episode.monetization_enabled ? 'ON' : 'OFF' }}
                </span>
            </div>
        </div>
        
        <!-- Price Section - Only when enabled -->
        <div *ngIf="episode.monetization_enabled" class="pt-2 border-t border-gray-200 dark:border-gray-700">
            <div class="flex items-center justify-between">
                <div>
                    <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Price per read
                        <span class="text-green-600 dark:text-green-400 text-xs ml-1">
                            (Free for author)
                        </span>
                    </label>
                    
                    <!-- Inline Edit Amount -->
                    <div class="flex items-center space-x-2">
                        <div class="flex items-center bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-1.5">
                            <span class="text-gray-500 dark:text-gray-400 mr-1">₹</span>
                            
                            <!-- Edit Mode -->
                            <input 
                                *ngIf="editingMonetizationId === episode.content_id"
                                type="number" 
                                [(ngModel)]="tempMonetizationAmount"
                                min="1" 
                        max="1000" 
                        step="0.5"
                                class="w-20 bg-transparent border-none focus:ring-0 focus:outline-none text-gray-800 dark:text-gray-200"
                                placeholder="0.00"
                                autofocus>
                            
                            <!-- View Mode -->
                            <span *ngIf="editingMonetizationId !== episode.content_id" 
                                  class="text-gray-800 dark:text-gray-200 font-medium">
                                {{ episode.monetization_amount }}
                            </span>
                            
                            <!-- Edit/Save Buttons -->
                            <div class="ml-2 flex space-x-1">
                                <button 
                                    *ngIf="editingMonetizationId === episode.content_id"
                                    (click)="saveMonetizationAmount(episode)"
                                    [disabled]="monetizationLoading"
                                    class="p-1 text-green-600 hover:text-green-700 disabled:opacity-50">
                                    <i class="fas fa-check text-xs"></i>
                                </button>
                                <button 
                                    *ngIf="editingMonetizationId === episode.content_id"
                                    (click)="cancelEditMonetization()"
                                    class="p-1 text-gray-500 hover:text-gray-700">
                                    <i class="fas fa-times text-xs"></i>
                                </button>
                                <button 
                                    *ngIf="editingMonetizationId !== episode.content_id"
                                    (click)="editMonetizationAmount(episode)"
                                    class="p-1 text-blue-500 hover:text-blue-600">
                                    <i class="fas fa-edit text-xs"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Quick Stats -->
                <div class="text-right">
                    <div class="text-xs text-gray-500 dark:text-gray-400">Estimated</div>
                    <div class="text-sm font-semibold text-gray-800 dark:text-gray-200">
                        ₹{{ (episode.monetization_amount * 0.7).toFixed(2) }}
                    </div>
                    <div class="text-xs text-gray-500 dark:text-gray-400">per 100 reads</div>
                </div>
            </div>
            
            <!-- Helper Text -->
            <div class="mt-2 text-xs text-gray-600 dark:text-gray-400 flex items-center">
                <i class="fas fa-info-circle text-blue-500 mr-1.5"></i>
                Readers pay ₹{{ episode.monetization_amount }} to unlock this episode
            </div>
        </div>
        
        <!-- Monetization Status -->
        <div *ngIf="!episode.monetization_enabled && isMonetized" 
             class="text-xs text-gray-600 dark:text-gray-400 italic">
            Turn on to make this a premium episode
        </div>
        
        <!-- Eligibility Messages -->
        <div *ngIf="!isMonetized" 
             class="mt-2 p-2 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg">
            <div class="flex items-start">
                <i class="fas fa-exclamation-triangle text-yellow-500 mt-0.5 mr-2 text-xs"></i>
                <div>
                    <div class="text-xs font-medium text-yellow-800 dark:text-yellow-300">
                        Channel not monetized
                    </div>
                    <div class="text-xs text-yellow-700 dark:text-yellow-400 mt-0.5">
                        Complete eligibility criteria to enable premium episodes
                    </div>
                </div>
            </div>
        </div>
        
        <!-- <div *ngIf="isMonetized" 
             class="mt-1 text-xs text-green-600 dark:text-green-400 flex items-center">
            <i class="fas fa-check-circle mr-1.5"></i>
            Your channel is eligible for monetization
        </div> -->
    </div>
</div>
                                <div class="flex justify-between items-center mt-3">
                                    <span class="text-xs lg:text-sm text-wattpad-light">{{t('UPDATED')}}: {{ getTimeAgo(getValidDate(episode)) }}</span>
                                    
                                    <!-- Only show Edit button for drafts -->
                                    <button *ngIf="episode.status == 0" 
                                            (click)="goToEdit(episode)" 
                                            class="pointer text-xs lg:text-sm bg-wattpad-primary text-white px-3 py-1 rounded-full hover:bg-[#E5274B] transition-colors">
                                        {{t('EDIT')}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>